export const tr = {
    seconds: 'sn'
};
